<template>
  <page-content v-has-permission="'user_role_view'">

    <panel ref="searchFormPanel" :is-open.sync="showFormSearch" show-close show-collapse title="Thông tin tìm kiếm">
      <c-form ref="searchForm" @submit="search()">

        <b-row>
          <b-col>
            <c-input v-model.trim="searchForm.username" label="Username"
            />
          </b-col>
          <b-col>
            <c-select2 v-model.number="searchForm.roleId"
                       label="Vai trò"
                       placeholder="Nhập mã vai trò"
                       uri="cms/api/v1.0/admin/roles/select2"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>
            <button class="btn btn-secondary" type="reset" @click="resetFormSearch()">
              <i class="fas fa-redo-alt"></i>
              Xóa bộ lọc
            </button>
          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel ref="panel" show-collapse title="Danh sách hành động">
      <template #btn>
        <li>
          <a v-b-tooltip.hover title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="showFormSearch = !showFormSearch">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :data-filter="searchForm"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Username', sortField:'username', sortable: true},
                   {text: 'Mã vai trò', sortField:'roleCode', sortable: true},
                   {text: 'Người tạo', sortField:'createdBy', sortable: true},
                   {text: 'Thời gian tạo', sortField:'createdAt', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
               uri="/cms/api/v1.0/admin/role-user/get-all"
      >
        <template #button>
          <b-button v-has-permission="'user_role_create'" size="sm" variant="success"
                    @click="$refs.formCreate.open()"
          >
            <i class="fas fa-plus-circle"></i> Thêm mới
          </b-button>
        </template>
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.roleCode }}</td>
          <td>{{ item.createdBy }}</td>
          <td>{{ item.createdAt | datetime }}</td>
          <td class="text-center">
            <b-button
                v-has-permission="'user_role_delete'"
                class="btn btn-icon"
                title="Xóa"
                type="button"
                variant="danger"
                @click="deleteItem(item)"
            >
              <i class="far fa-trash-alt"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>

    <add ref="formCreate" @success="search(); "/>
    <update ref="formUpdate" @success="search()"/>
    <delete ref="deleteConfirmDialog" @success="search()"/>
  </page-content>
</template>

<script>
import Add from './Add';
import Delete from './Delete';

export default {
  name: "Index",
  components: {
    Add,
    Delete,
  },
  data() {
    return {
      searchForm: {
        username: null,
        roleId: null,
      },
      showFormSearch: false
    }
  },
  methods: {
    search() {
      this.$refs.table.reload();
    },
    resetFormSearch() {
      this.searchForm.username = null;
      this.searchForm.roleId = null;

      this.search();
    },
    update(item) {
      this.$refs.formUpdate.open(item.id);
    },
    deleteItem(item) {
      this.$refs.deleteConfirmDialog.open(item);
    }
  }
}
</script>

<style scoped>

</style>